import React, { useState } from "react";
import axios from 'axios';
import './Membership.css';
import { useNavigate } from 'react-router-dom';
import { BACKEND_URL } from '../../../config';

const API = BACKEND_URL;

const Signup = ({ closeModal, compact = false }) => {
  const [formData, setFormData] = useState({ name: '', phone: '', email: '' });
  const [stage, setStage] = useState('form'); // form, verify, done
  const [phoneOtp, setPhoneOtp] = useState('');
  const [emailOtp, setEmailOtp] = useState('');

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [countdown, setCountdown] = useState(0);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const sendOtp = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      // send OTP to both phone and email if provided
      const payload = { name: formData.name };
      if (formData.phone) payload.phone = formData.phone;
      if (formData.email) payload.email = formData.email;
      const res = await axios.post(`${API}/api/auth/signup/send-otp`, payload);
      setStage('verify');
      setCountdown(60);
      // Show OTP in development mode (for testing)
    } catch (err) {
      setError(err?.response?.data?.message || 'Unable to send OTP');
    } finally {
      setLoading(false);
    }
  };

  const resendOtp = async () => {
    if (countdown > 0) return;
    setError(''); setLoading(true);
    try {
      const payload = { name: formData.name };
      if (formData.phone) payload.phone = formData.phone;
      if (formData.email) payload.email = formData.email;
      const res = await axios.post(`${API}/api/auth/signup/send-otp`, payload);
      setCountdown(60);
    } catch (err) {
      setError(err?.response?.data?.message || 'Unable to resend OTP');
    } finally { setLoading(false); }
  };

  React.useEffect(()=>{
    if (countdown <= 0) return;
    const t = setInterval(()=> setCountdown(c=> c-1), 1000);
    return ()=> clearInterval(t);
  },[countdown]);

  const verifyOtp = async () => {
    setError('');
    setLoading(true);
    try {
      const payload = { name: formData.name };
      if (formData.phone) {
        payload.phone = formData.phone;
        payload.phoneOtp = phoneOtp || undefined;
      }
      if (formData.email) {
        payload.email = formData.email;
        payload.emailOtp = emailOtp || undefined;
      }
      const res = await axios.post(`${API}/api/auth/signup/verify`, payload);
      // Store the token in localStorage
      if (res.data.token) {
        localStorage.setItem('ihn_token', res.data.token);
      }
      // close modal (if provided) then navigate to user's profile
      try{ if (typeof closeModal === 'function') closeModal(); }catch(e){}
      
      if (res.data?.user?.username) {
        navigate(`/profile/${res.data.user.username}`);
      } else {
        navigate('/dashboard');
      }
    } catch (err) {
      setError(err?.response?.data?.message || 'OTP verification failed');
    } finally {
      setLoading(false);
    }
  };

  const navigate = useNavigate();

  // Compact popup layout
  if (compact) {
    return (
      <div >
        
        {stage === 'form' && (
          <div>
            <input
              placeholder="Full name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              style={{width:'100%',padding:12,borderRadius:12,border:'1px solid #e6e6e6',marginBottom:8}}
            />

            <input
              placeholder="Mobile number (optional)"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              style={{width:'100%',padding:12,borderRadius:12,border:'1px solid #e6e6e6',marginBottom:8}}
            />

            <input
              placeholder="Email (optional)"
              name="email"
              value={formData.email}
              onChange={handleChange}
              style={{width:'100%',padding:12,borderRadius:12,border:'1px solid #e6e6e6',marginBottom:8}}
            />

            {error && <div className="error">{error}</div>}
            <button className="btn primary center" style={{marginTop:8, minWidth:120}} onClick={sendOtp} disabled={loading || !(formData.phone||formData.email)}>{loading? '...' : 'Send OTP'}</button>
          </div>
        )}

        {stage === 'verify' && (
          <div style={{marginTop:8}}>
            {formData.phone && (
              <input placeholder="Enter Phone OTP" value={phoneOtp} onChange={e=>setPhoneOtp(e.target.value)} style={{width:'100%',padding:12,borderRadius:12,border:'1px solid #e6e6e6',marginBottom:8}} />
            )}
            {formData.email && (
              <input placeholder="Enter Email OTP" value={emailOtp} onChange={e=>setEmailOtp(e.target.value)} style={{width:'100%',padding:12,borderRadius:12,border:'1px solid #e6e6e6'}} />
            )}
            <div style={{display:'flex',gap:8,marginTop:8}}>
              <button className="btn" onClick={()=>setStage('form')}>Back</button>
              <button className="btn" onClick={resendOtp} disabled={countdown>0}>{countdown>0?`Resend in ${countdown}s`:'Resend'}</button>
              <button className="btn primary" onClick={verifyOtp} disabled={loading}>Verify</button>
            </div>
            {error && <div className="error">{error}</div>}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="membership-wrap">
      <div className="membership-card">

        {stage === 'form' && (
          <form className="membership-form" onSubmit={sendOtp}>
            <label className="field">
              <span className="label">Full name</span>
              <input name="name" value={formData.name} onChange={handleChange} required />
            </label>

            <label className="field">
              <span className="label">Phone number</span>
              <input name="phone" value={formData.phone} onChange={handleChange} placeholder="e.g. +1234567890" />
            </label>
            <label className="field">
              <span className="label">Email (optional)</span>
              <input name="email" value={formData.email} onChange={handleChange} placeholder="your@email.com" />
            </label>

            {error && <div className="error">{error}</div>}

            <button className="otp-btn" type="submit" disabled={loading}>
              {loading ? <span className="loader" /> : 'Send OTP'}
            </button>
          </form>
        )}

        {stage === 'verify' && (
          <div className="membership-form">
            <p className="muted">We sent OTP(s) to the provided contact(s). Enter them below to verify.</p>

            {formData.phone && (
              <label className="field">
                <span className="label">Phone OTP</span>
                <input value={phoneOtp} onChange={e => setPhoneOtp(e.target.value)} />
              </label>
            )}
            {formData.email && (
              <label className="field">
                <span className="label">Email OTP</span>
                <input value={emailOtp} onChange={e => setEmailOtp(e.target.value)} />
              </label>
            )}

            {error && <div className="error">{error}</div>}

            <div className="actions">
              <button className="btn" onClick={() => setStage('form')} disabled={loading}>Back</button>
              <div style={{display:'flex',alignItems:'center',gap:8}}>
                <button className="btn" onClick={resendOtp} disabled={loading || countdown>0}>{countdown>0?`Resend in ${countdown}s`:'Resend'}</button>
                <button className="btn primary" onClick={verifyOtp} disabled={loading}>{loading ? <span className="loader" /> : 'Verify'}</button>
              </div>
            </div>
          </div>
        )}

        {stage === 'done' && (
          <div className="membership-done">
            <h3>Signup completed</h3>
            <p className="muted">You can now login using your phone or email.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Signup;
